import './styles.scss'

import React from 'react'

export default () => <div className='generic-overlay' />
